import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { escapeHtml } from '../../shared/html.helper';

@Pipe({
  name: 'highlightSearch',
})
export class HighlightSearchPipe implements PipeTransform {
  constructor(private dom: DomSanitizer) {}

  transform(item: any, _search: string): SafeHtml {
    const text = item == null ? '' : String(item);
    const escaped = escapeHtml(text);

    if (!_search || !String(_search).trim()) {
      return this.dom.bypassSecurityTrustHtml(escaped);
    }

    const search = String(_search).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const terms = search.split(' ').filter(Boolean);
    if (terms.length === 0) {
      return this.dom.bypassSecurityTrustHtml(escaped);
    }

    const re = new RegExp('(' + terms.join('|') + ')', 'gi');
    const highlighted = escaped.replace(re, '<span style="font-weight: bold">$1</span>');
    return this.dom.bypassSecurityTrustHtml(highlighted);
  }
}
